// @flow

import { cmsAxios } from './axios-config';

const getMedia = () => {
  return cmsAxios.get('/media');
};

export default getMedia;
